export const visit = (vm, at) => {
at({ "da": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} af {{totalBytes}}" }, "fileSizeLimit": "Filen m\xE5 ikke v\xE6re st\xF8rre end {{size}}", "screenCapture": "Sk\xE6rmbillede" } } });
};